import "../globals/global.css"
import "./missingpage.css"

const MissingPage = () => {
   return (
    <div className="pagebackground">
        <div className="aa">
            <div className="centrediv"> <div className="boxtext">You've gone to a page that doesnt exist, go back to <a href="https://hng-group.com" >the home page</a> <br/>if you believe this to be a mistake, feel free to reach out to one of the devs!</div> </div>
        </div>
    </div>
  );
};
export default MissingPage;